<table class="table align-middle table-row-dashed fs-8 no-footer">
  <thead>
    <tr class="text-start text-gray-800 fs-8 text-uppercase">
      <ng-container *ngIf="mode === 'corporate'">
        <th>Member #</th>
        <th>Suffix</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Relationship</th>
        <th>DOB</th>
        <th>Joined</th>
        <th>Scheme</th>
        <th class="text-end">Amount</th>
      </ng-container>
      <ng-container *ngIf="mode === 'member'">
        <th>Suffix</th>
        <th>Relationship</th>
        <th>Name</th>
        <th>Scheme</th>
        <th class="text-end">Amount</th>
        <th>Item Scheme</th>
      </ng-container>
    </tr>
  </thead>
  <tbody class="fw-semibold text-gray-700">
    <tr *ngIf="!items || items.length === 0">
      <td [attr.colspan]="mode === 'corporate' ? 9 : 6" class="py-5 text-center text-gray-500">
        No items on this invoice.
      </td>
    </tr>

    <!-- Corporate row -->
    <ng-container *ngIf="mode === 'corporate'">
      <tr *ngFor="let item of items"
          [ngClass]="{ 'bg-light-warning': isAdjustmentLine(item) }">
        <td>#{{ asCorporate(item).member_number }}</td>
        <td>#{{ item.beneficiary_number }}</td>
        <td>{{ asCorporate(item).dependent?.first_name }}</td>
        <td>
          <div>{{ asCorporate(item).dependent?.last_name }}</div>
          <small *ngIf="item.note"
                 [ngClass]="isAdjustmentLine(item) ? 'text-warning fw-bolder' : 'text-gray-500 fst-italic'">
            <i class="bi"
               [ngClass]="isAdjustmentLine(item) ? 'bi-arrow-right-circle' : 'bi-info-circle'"></i>
            {{ item.note }}
          </small>
        </td>
        <td>{{ asCorporate(item).dependent?.relationship }}</td>
        <td>{{ asCorporate(item).dependent?.date_of_birth | date : 'd MMM, yyyy' }}</td>
        <td>{{ asCorporate(item).dependent?.date_joined | date : 'd MMM, yyyy' }}</td>
        <td>{{ item.scheme_code }}</td>
        <td class="text-end">
          <span [ngClass]="amountClass(item)">
            {{ item.contribution_amount | customCurrency : currency }}
          </span>
        </td>
      </tr>
    </ng-container>

    <!-- Member row -->
    <ng-container *ngIf="mode === 'member'">
      <tr *ngFor="let item of items"
          [ngClass]="{ 'bg-light-warning': isAdjustmentLine(item) }">
        <td>#{{ item.beneficiary_number }}</td>
        <td>{{ item.relationship }}</td>
        <td>
          <div>{{ asMember(item).dependent?.getFullName() }}</div>
          <small *ngIf="item.note"
                 [ngClass]="isAdjustmentLine(item) ? 'text-warning fw-bolder' : 'text-gray-500 fst-italic'">
            <i class="bi"
               [ngClass]="isAdjustmentLine(item) ? 'bi-arrow-right-circle' : 'bi-info-circle'"></i>
            {{ item.note }}
          </small>
        </td>
        <td>{{ asMember(item).dependent?.scheme_code }}</td>
        <td class="text-end">
          <span [ngClass]="amountClass(item)">
            {{ item.contribution_amount | customCurrency : currency }}
          </span>
        </td>
        <td>{{ item.scheme_code }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>
